export const errorCodes = {
  InvalidHashkeyRequested: 60,
  EntityAlreadyExistsError: 101,
  EntityDoesNotExistException: 104,
  MediaPlanStatusUpdateFailedException: 110,
  NoCampaignsLinkedException: 111,
  StripeException: 201,
  EntityNotFoundInCacheException: 308,
  InvalidLoginCredentials: 51,
  ForbiddenPortalRequested: 56,
  ForbiddenBusinessProfileRequested: 113,
  InvalidPortalRequestedException: 55,
  InvalidBusinessProfileRequested: 112,
  Unauthorized: 401,
  TokenMalformedException: 61,
  TokenExpiredException: 62,
  TokenInvalidException: 63,
  InvalidRequestDataException: 102,
  UserAccountExpiredException: 52,
  EmailAlreadyVerifiedError: 65,
  HtmlWebClientException: 706,
  OtpAlreadyGeneratedException: 800,
  InvalidOtpException: 57,
  OtpVerificationAttemptsExceededException: 801,
  FacebookPageAlreadyRequestedException: 331,
  UnsplashApiException: 318,
  PasswordExpiredException: 74,
  OldPasswordException: 75,
  WeakPasswordException: 84,
  RefreshTokenExpiredException: 76
};
